export default __webpack_public_path__ + "static/media/doc_white_dwdw.24dfacfd.svg";